import React, { useEffect, useState } from "react"
import {
  Container,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  Form,
  Input,
  Label,
} from "reactstrap"
import Breadcrumbs from "../../../../components/Common/Breadcrumb"
import { Link, useNavigate } from "react-router-dom"
import { useMemo } from "react"
import {
  useTable,
  useSortBy,
  usePagination,
  useGlobalFilter,
} from "react-table"
// import "../../FinanceModule/Finance.css"
import ReactSelect from "react-select"
import Select from "react-select"
import {
  Table,
  Row,
  Col,
  Card,
  CardBody,
  Badge,
  Modal,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from "reactstrap"
import classnames from "classnames"
import Draggable, { DraggableCore } from "react-draggable"
import { Resizable, ResizableBox } from "react-resizable"
import dayoff from "../../../../assets/images/dayoff.jpg"
// common component
import NewPagination from "components/Common/Newpagination"

// Hover card
import ProfileDetails from "components/Common/ProfileDetails"
import axios, { Axios } from "axios"
import Loader from "pages/Separate/Loader"
import swal from "sweetalert"

import configure from "configure"
import Swal from "sweetalert2"
import AccessDeniedPopup from "routes/AccessDeniedPopup"
import moment from "moment"
import { current } from "@reduxjs/toolkit"
import { CSVLink } from "react-csv"
import "../../../../assets/css/Finance/Style/PayrollManagement/payroll_management.css"
// function TableContainer({ columns, data }) {
//   const [fixedContent, setFixedContent] = useState(false)

//   const navigate = useNavigate()

//   document.addEventListener("keydown", e => {
//     if (e.key === "Escape") setAddExpense(false)
//   })

//   document.addEventListener("scroll", () => {
//     if (window.scrollY > 165) {
//       setFixedContent(true)
//     } else {
//       setFixedContent(false)
//     }
//   })

//   // Use the state and functions returned from useTable to build your UI
//   const {
//     getTableProps,
//     getTableBodyProps,
//     headerGroups,
//     page,
//     state,
//     previousPage,
//     nextPage,
//     canPreviousPage,
//     canNextPage,
//     gotoPage,
//     setPageSize,
//     pageOptions,
//     setGlobalFilter,
//     pageCount,
//     prepareRow,
//   } = useTable(
//     {
//       columns,
//       data,
//       initialState: {
//         sortBy: [
//           {
//             id: "id", // Set the ID of the first column for default sorting
//             desc: true, // `true` for descending, `false` for ascending
//           },
//         ],
//       },
//     },

//     useGlobalFilter,
//     useSortBy,
//     usePagination
//   )
//   const { pageIndex, pageSize, globalFilter } = state
//   useEffect(() => setPageSize(50), [])

//   const excelColumns = []
//   columns.forEach(column => {
//     column.Header !== "Action" && excelColumns.push(column.Header)
//   })

//   const csvData = [
//     excelColumns,
//     ...data.map(
//       ({
//         id,
//         date,
//         title,
//         invoiceNo,
//         customer,
//         tdsReceive,
//         category,
//         debit,
//         credit,
//       }) => [
//         id,
//         date,
//         title,
//         invoiceNo,
//         customer,
//         tdsReceive,
//         category,
//         debit,
//         credit,
//       ]
//     ),
//   ]

//   const [title, setTitle] = useState("")
//   const [name_modal, setNameModal] = useState(false)

//   // Render the UI for your table
//   return (
//     <div>
//       {/* fixed buttons */}
//       <div
//         className={`flex-column fixed-buttons pt-4 mt-3 ${
//           fixedContent ? "d-flex" : "d-none"
//         }`}
//       >
//         <Link
//           onClick={() => setCreateSalarySheet(true)}
//           className="btn btn-save  fix-btn btn-label pe-0"
//         >
//           <i className="fas fa-plus me-2 icon-size label-icon"></i>
//           <span>Generate Salary Sheet</span>
//         </Link>

//         <button
//           onClick={() => navigate(-1)}
//           className="btn btn-red  fix-btn btn-label pe-0"
//         >
//           <i className="dripicons-cross me-2 icon-center label-icon"></i>
//           <span>Cancel</span>
//         </button>
//       </div>

//       {/* <Row className="mb-4">
//       </Row> */}
//       <Row className="d-flex mt-4">
//         <div className="d-flex col-md-8 justify-flex-start align-items-center gap-2">
//           <div className="col-md-3 budget_status text-primary pt-2 px-2 me-5 rounded proposal-status text-center">
//             <h6>Total Amount</h6>
//             <h3>₹ 10,15,240</h3>
//           </div>
//         </div>

//         <div className="col-md-4 text-end">
//           <div className="">
//             <CSVLink
//               className="border-radius btn  text-white me-2 btn-success btn-label"
//               filename="tds_zithas.csv"
//               data={csvData}
//             >
//               <i className="fas fa-download me-2 icon-size label-icon"></i>{" "}
//               Export CSV
//             </CSVLink>
//             <button
//               className=" btn btn-save btn-label"
//               onClick={() => setAddExpense(true)}
//             >
//               <i className="fas fa-plus me-2 label-icon"></i>
//               Generate Salary Sheet
//             </button>
//           </div>
//         </div>
//       </Row>
//       <Row className="m-0 d-flex justify-space-between align-items-center">
//         <div className="p-0 col-md-2">
//           <select
//             className=" form-select mt-4"
//             style={{ width: "100px" }}
//             value={pageSize}
//             onChange={e => setPageSize(e.target.value)}
//           >
//             {[10, 25, 50, 100].map(pageSize => (
//               <option key={pageSize} value={pageSize}>
//                 Show {pageSize}
//               </option>
//             ))}
//           </select>
//         </div>
//         <div className="p-0 col-md-2">
//           <div className="search-box my-xxl-0 d-inline-block ">
//             <div className="position-relative  mt-4">
//               <label htmlFor="search-bar-0" className="search-label">
//                 <span id="search-bar-0-label" className="sr-only">
//                   Search this table
//                 </span>
//                 <input
//                   onChange={e => setGlobalFilter(e.target.value)}
//                   id="search-bar-0"
//                   type="text"
//                   className=" form-control rounded h-100 "
//                   placeholder={` Search...`}
//                   value={globalFilter || ""}
//                 />
//               </label>
//               <i className="bx bx-search-alt search-icon"></i>
//             </div>
//           </div>
//         </div>
//       </Row>
//       <div className="position-relative">
//         <Table className="table table-bordered" {...getTableProps()}>
//           <thead
//             className={`${
//               fixedContent ? "fixed-salary-mng-header" : "fix-table-header"
//             } `}
//           >
//             {headerGroups.map((headerGroup, i) => (
//               <tr key={i} {...headerGroup.getHeaderGroupProps()}>
//                 {headerGroup.headers.map((column, index) => {
//                   const classNames = column.className
//                   return (
//                     <th
//                       key={index}
//                       className={` col-t-${index + 1} ${classNames}`}
//                       // {...column.getHeaderProps()}
//                       {...column.getHeaderProps(column.getSortByToggleProps())}
//                     >
//                       <div
//                         className={`position-relative d-flex ${
//                           column.isShortIcon
//                             ? "justify-content-between"
//                             : "justify-content-center"
//                         }`}
//                       >
//                         {index === 0 && <span></span>}
//                         <span
//                           style={{
//                             position: index === 0 ? "absolute" : "",
//                             left: index === 0 ? "45%" : "",
//                           }}
//                         >
//                           {column.render("Header")}
//                         </span>
//                         {column.isShortIcon ? (
//                           <span
//                             style={{
//                               position: index != 0 ? "absolute" : "",
//                               right: index != 0 ? "0" : "",
//                             }}
//                             onClick={() =>
//                               column.getSortByToggleProps().onClick()
//                             }
//                           >
//                             <i
//                               title="Ascending"
//                               className={`bi bi-arrow-up ms-1 info-icon ${
//                                 column.isSorted && !column.isSortedDesc
//                                   ? "text-dark"
//                                   : ""
//                               }`}
//                             ></i>
//                             <i
//                               title="Descending"
//                               className={`bi bi-arrow-down info-icon ${
//                                 column.isSorted && column.isSortedDesc
//                                   ? "text-dark"
//                                   : ""
//                               }`}
//                             ></i>
//                           </span>
//                         ) : null}
//                       </div>
//                     </th>
//                   )
//                 })}
//               </tr>
//             ))}
//           </thead>

//           <tbody className="fix-salary-table-body" {...getTableBodyProps()}>
//             {page.map((row, i) => {
//               prepareRow(row)
//               const { did_col: did, pwd_col: pwd } = row.original
//               const status = row.original.status_name

//               let backgroundStyle = {}

//               const priority = row.original.priority_col

//               return (
//                 <tr {...row.getRowProps()} key={i} style={backgroundStyle}>
//                   {row.cells.map((cell, index) => (
//                     <td
//                       key={index}
//                       className={`t-col-${index + 1} ${cell.column.className} ${
//                         priority == "High" ? "highPriority" : ""
//                       }`}
//                       {...cell.getCellProps()}
//                     >
//                       {cell.render("Cell")}
//                     </td>
//                   ))}
//                 </tr>
//               )
//             })}
//           </tbody>
//         </Table>
//       </div>

//       {/* Pagination */}
//       <Row className="justify-content-md-end justify-content-center align-items-center">
//         <NewPagination
//           gotoPage={gotoPage}
//           canPreviousPag={canPreviousPage}
//           canNextPage={canNextPage}
//           pageIndex={pageIndex}
//           pageOptions={pageOptions}
//           pageSize={pageSize}
//           page={page}
//           data={data}
//         />
//       </Row>
//     </div>
//   )
// }


function TableContainer({ columns, data }) {
  const [fixedContent, setFixedContent] = useState(false)
  const [formPopup, setFormPopup] = useState(false)

  // const [salaryCalculation, setSalaryCalculation] = useState(false);

  const navigate = useNavigate()

  document.addEventListener("scroll", () => {
    if (window.scrollY > 256) {
      setFixedContent(true)
    } else {
      setFixedContent(false)
    }
  })

  // Use the state and functions returned from useTable to build your UI
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    state,
    previousPage,
    nextPage,
    canPreviousPage,
    canNextPage,
    gotoPage,
    setPageSize,
    pageOptions,
    setGlobalFilter,
    pageCount,
    prepareRow,
  } = useTable(
    {
      columns,
      data,
      initialState: {
        sortBy: [
          {
            id: "id", // Set the ID of the first column for default sorting
            desc: true, // `true` for descending, `false` for ascending
          },
        ],
      },
    },

    useGlobalFilter,
    useSortBy,
    usePagination
  )

  
  const { pageIndex, pageSize, globalFilter } = state
    useEffect(() => setPageSize(50), [])
  // Functionality to export table data to CSV //
  const excelColumns = []
  columns.forEach(column => {
    excelColumns.push(column.Header)
  })

  const csvData = [
    excelColumns,
    ...data.map(
      ({ id, date, title, invoiceNo, customer, category, debit, credit }) => [
        id,
        date,
        title,
        invoiceNo,
        customer,
        category,
        debit,
        credit,
      ]
    ),
  ]
  // ======================================================= //

  const handleSalaryCalculation = async () => {
    Swal.fire({
      title: "Are you sure to calculate salary?",
      icon: "warning",
      text: "if confirm then it will take around 1 to 2 minutes. please don't refresh the page",
      showCancelButton: true,
      confirmButtonText: "Confirm",
    }).then(willOkay => {
      if (willOkay.isConfirmed) {
        Swal.fire({
          icon: "success",
          text: "Calculation Successfully Completed",
        })
      }
    })
  }

  const handleAccessPreview = async () => {
    Swal.fire({
      title: "Are you sure?",
      icon: "warning",
      text: "Are you sure you want grant access punching preview to employees ?",
      showCancelButton: true,
      confirmButtonText: "Confirm",
    }).then(willOkay => {
      if (willOkay.isConfirmed) {
        Swal.fire({
          icon: "success",
          text: "Punching preview is granted for employees",
        })
      }
    })
  }

  const month_option = [
    { label: "January", value: "January" },
    { label: "February", value: "February" },
    { label: "March", value: "March" },
    { label: "April", value: "April" },
    { label: "May", value: "May" },
    { label: "June", value: "June" },
    { label: "July", value: "July" },
    { label: "August", value: "August" },
    { label: "September", value: "September" },
    { label: "October", value: "October" },
    { label: "November", value: "November" },
    { label: "December", value: "December" },
  ]
  const year_option = [
    { label: "2024", value: "2024" },
    { label: "2023", value: "2023" },
    { label: "2022", value: "2022" },
    { label: "2021", value: "2021" },
  ]
  // Render the UI for your table
  return (
    <div>
      {/* fixed buttons */}
      <div
        className={`flex-column fixed-buttons pt-4 mt-3 ${
          fixedContent ? "d-flex" : "d-none"
        }`}
      >
        <Link
          onClick={() => setCreateSalarySheet(true)}
          className="btn btn-save  fix-btn pe-0"
        >
          {/* <i className="fas fa-plus me-2 icon-size label-icon"></i> */}
          <span>Generate </span>
        </Link>
       

        <button
          onClick={() => navigate(-1)}
          className="btn btn-red  fix-btn btn-label pe-0"
        >
          <i className="dripicons-cross me-2 icon-center label-icon"></i>
          <span>Cancel</span>
        </button>
      </div>

      {/* <Row className="mb-4">
          </Row> */}
      <Row className="d-flex mt-4">
        <div className="d-flex col-md-8 justify-flex-start align-items-center gap-2">
          <div className="col-sm-3 budget_status text-primary py-3 px-2 me-5 rounded proposal-status d-flex justify-content-center align-items-center gap-2">
            <h4>Total Amount:</h4>
            <h4>₹ 10,240</h4>
          </div>
        </div>

        <div className="col-md-4 text-end">
          <div className="">
            <CSVLink
              className="border-radius btn  text-white me-2 btn-success btn-label"
              filename="tds_zithas.csv"
              data={csvData}
            >
              <i className="fas fa-download me-2 icon-size label-icon"></i>{" "}
              Export CSV
            </CSVLink>
            <button
              className=" btn btn-save "
              onClick={() => setAddExpense(true)}
            >
              {/* <i className="fas fa-plus me-2 label-icon"></i> */}
              Generate Salary Sheet
            </button>
          </div>
        </div>
      </Row>
      <Row className="m-0 d-flex justify-space-between align-items-center">
        <div className="p-0 col-md-2">
          <select
            className=" form-select mt-4"
            style={{ width: "100px" }}
            value={pageSize}
            onChange={e => setPageSize(e.target.value)}
          >
            {[10, 25, 50, 100].map(pageSize => (
              <option key={pageSize} value={pageSize}>
                Show {pageSize}
              </option>
            ))}
          </select>
        </div>
        <div className="p-0 col-md-2 d-flex">
          
          <div className="search-box my-xxl-0 d-inline-block d-flex flex-row justify-content-center align-items-center">
            <button
              onClick={() => setFormPopup(!formPopup)}
              className="btn btn-outline-secondary  me-3"
            >
              <i className="fas fa-filter"></i>
            </button>
            <div className="position-relative  mt-4  mb-3">
              <label htmlFor="search-bar-0" className="search-label">
                <span id="search-bar-0-label" className="sr-only">
                  Search this table
                </span>
                <input
                  onChange={e => setGlobalFilter(e.target.value)}
                  id="search-bar-0"
                  type="text"
                  className=" form-control rounded h-100 "
                  placeholder={` Search...`}
                  value={globalFilter || ""}
                />
              </label>
              <i className="bx bx-search-alt search-icon"></i>
            </div>
          </div>
        </div>
      </Row>
      <div className="position-relative">
        <Table className="table table-bordered" {...getTableProps()}>
          <thead
            className={`${
              fixedContent ? "fixed-salary-mng-header" : "fix-table-header"
            } `}
          >
            {headerGroups.map((headerGroup, i) => (
              <tr key={i} {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column, index) => {
                  const classNames = column.className
                  return (
                    <th
                      key={index}
                      className={` col-t-${index + 1} ${classNames}`}
                      // {...column.getHeaderProps()}
                      {...column.getHeaderProps(column.getSortByToggleProps())}
                    >
                      <div
                        className={`position-relative d-flex ${
                          column.isShortIcon
                            ? "justify-content-between"
                            : "justify-content-center"
                        }`}
                      >
                        {index === 0 && <span></span>}
                        <span
                          style={{
                            position: index === 0 ? "absolute" : "",
                            left: index === 0 ? "45%" : "",
                          }}
                        >
                          {column.render("Header")}
                        </span>
                        {column.isShortIcon ? (
                          <span
                            style={{
                              position: index != 0 ? "absolute" : "",
                              right: index != 0 ? "0" : "",
                            }}
                            onClick={() =>
                              column.getSortByToggleProps().onClick()
                            }
                          >
                            <i
                              title="Ascending"
                              className={`bi bi-arrow-up ms-1 info-icon ${
                                column.isSorted && !column.isSortedDesc
                                  ? "text-dark"
                                  : ""
                              }`}
                            ></i>
                            <i
                              title="Descending"
                              className={`bi bi-arrow-down info-icon ${
                                column.isSorted && column.isSortedDesc
                                  ? "text-dark"
                                  : ""
                              }`}
                            ></i>
                          </span>
                        ) : null}
                      </div>
                    </th>
                  )
                })}
              </tr>
            ))}
          </thead>

          <tbody className="fix-salary-table-body" {...getTableBodyProps()}>
            {page.map((row, i) => {
              prepareRow(row)
              const { did_col: did, pwd_col: pwd } = row.original
              const status = row.original.status_name

              let backgroundStyle = {}

              const priority = row.original.priority_col

              return (
                <tr {...row.getRowProps()} key={i} style={backgroundStyle}>
                  {row.cells.map((cell, index) => (
                    <td
                      key={index}
                      className={`t-col-${index + 1} ${cell.column.className} ${
                        priority == "High" ? "highPriority" : ""
                      }`}
                      {...cell.getCellProps()}
                    >
                      {cell.render("Cell")}
                    </td>
                  ))}
                </tr>
              )
            })}
          </tbody>
        </Table>
      </div>

      {/* Pagination */}
      <Row className="justify-content-md-end justify-content-center align-items-center">
        <NewPagination
          gotoPage={gotoPage}
          canPreviousPag={canPreviousPage}
          canNextPage={canNextPage}
          pageIndex={pageIndex}
          pageOptions={pageOptions}
          pageSize={pageSize}
          page={page}
          data={data}
        />
      </Row>
      {formPopup ? (
        <div id="salary-filter">
          <div className="salary-popup-form p-4">
            <Form
              onSubmit={e => {
                e.preventDefault()
              }}
            >
              <Row className="align-items-end">
                <Row className="d-flex pe-0 me-0" style={{ width: "100%" }}>
                  <div className="col-md-2 mt-2">
                    <label htmlFor="">Month</label>
                    <Select
                      placeholder="Select Month"
                      className="basic-multi-select"
                      classNamePrefix=" select"
                      // styles={colourStyles}
                      options={month_option}
                      closeMenuOnSelect={false}
                    />
                  </div>
                  <div className="col-md-2 mt-2">
                    <label htmlFor="">Year</label>
                    <Select
                      placeholder="Select Year"
                      className="basic-multi-select"
                      classNamePrefix=" select"
                      // styles={colourStyles}
                      options={year_option}
                      closeMenuOnSelect={false}
                    />
                  </div>

                  <div className="col-md-4 mt-2">
                    <label htmlFor="">Save and Clear Filters</label>
                    <div>
                      <a
                        className="btn  btn-primary mr-10"
                        style={{
                          fontSize: "11px",
                          backgroundColor: "#93a6ff",
                          borderColor: "#93a6ff",
                          color: "black",
                        }}
                      >
                        Save Filters
                      </a>
                      <a
                        className="btn  btn-danger"
                        style={{
                          fontSize: "11px",
                          backgroundColor: "#fed36d",
                          borderColor: "#fed36d",
                          color: "black",
                        }}
                      >
                        Clear Filters
                      </a>
                    </div>
                  </div>
                  <div className="d-flex col-md-4 mb-1 align-items-end justify-content-end">
                    <div className="mr-10">
                      <button className="btn  btn-purple">
                        <i className="fas fa-filter search-icon me-1 icon-center"></i>{" "}
                        Filter
                      </button>
                    </div>
                    <div className="">
                      <a
                        className="btn  btn-red"
                        onClick={() => setFormPopup(false)}
                      >
                        <i className="dripicons-cross me-1 icon-center"></i>{" "}
                        Close
                      </a>
                    </div>
                  </div>
                </Row>
              </Row>
            </Form>
            <i className="bi bi-triangle-fill pop-icon"></i>
          </div>
        </div>
      ) : null}
    </div>
  )
}

const SalarySheet = () => {
  //   const [verticalActiveTab, setverticalActiveTab] = useState("1")

  const days = [
    { label: "1", value: "1" },
    { label: "2", value: "2" },
    { label: "3", value: "3" },
    { label: "4", value: "4" },
    { label: "5", value: "5" },
    { label: "7", value: "7" },
    { label: "8", value: "8" },
    { label: "9", value: "9" },
    { label: "10", value: "10" },
    { label: "11", value: "11" },
    { label: "12", value: "12" },
    { label: "13", value: "13" },
    { label: "14", value: "14" },
    { label: "15", value: "15" },
    { label: "16", value: "16" },
    { label: "17", value: "17" },
    { label: "18", value: "18" },
    { label: "19", value: "19" },
    { label: "20", value: "20" },
    { label: "21", value: "21" },
    { label: "22", value: "22" },
    { label: "23", value: "23" },
    { label: "24", value: "24" },
    { label: "25", value: "25" },
    { label: "26", value: "26" },
    { label: "27", value: "27" },
    { label: "28", value: "28" },
    { label: "29", value: "29" },
    { label: "30", value: "30" },
    { label: "31", value: "31" },
  ]
  const colourStyles = {
    control: (styles, state) => ({
      ...styles,
      backgroundColor: state.isDisabled ? "gray" : "white",
      // other styles
    }),
    // other style properties
  }

  const toggleVertical = tab => {
    if (verticalActiveTab !== tab) {
      setverticalActiveTab(tab)
    }
  }

  //meta title
  document.title = "Salary Sheet | Zithas Crm"

  const [view_customer, setVeiwCustomer] = useState([])
  const [isLoading, setLoading] = useState(false)

  const [applyNetLeave, setApplyNetLeave] = useState(false)

  const [modal_Access, setAccessDenied] = useState(false)

  //   document.addEventListener("keydown", e => {
  //     if (e.key === "Escape")

  //   })

  const navigate = useNavigate()

  // table columns
  const columns = useMemo(
    () => [
      {
        Header: "ID",
        accessor: "id",
        isInfoIcon: false,
        isShortIcon: true,
        className: "text-center salary-sr",
      },

      {
        Header: "Name",
        accessor: "name",
        isInfoIcon: true,
        isShortIcon: true,
        className: "salary-name",
      },

      {
        Header: "Total Days",
        accessor: "total_days",
        isInfoIcon: true,
        isShortIcon: true,
        className: "text-center salary-days",
      },
      {
        Header: "ASL",
        accessor: "asl",
        title: "Approved Sick Leave",
        isInfoIcon: true,
        isShortIcon: true,
        className: "text-center salary-asl",
      },
      {
        Header: "USL",
        accessor: "usl",
        title: "Unapproved Sick Leave",
        isInfoIcon: true,
        isShortIcon: true,
        className: "text-center salary-usl",
      },
      {
        Header: "AEL",
        accessor: "ael",
        title: "Approved Earned Leave",
        isInfoIcon: true,
        isShortIcon: true,
        className: "text-center salary-ael",
      },
      {
        Header: "UEL",
        accessor: "uel",
        title: "Unapproved Earned Leave",
        isInfoIcon: true,
        isShortIcon: true,
        className: "text-center salary-uel",
      },
      {
        Header: "ACL",
        accessor: "acl",
        title: "Approved Casual Leave",
        isInfoIcon: true,
        isShortIcon: true,
        className: "text-center salary-acl",
      },
      {
        Header: "UCL",
        accessor: "ucl",
        title: "Unapproved Casual Leave",
        isInfoIcon: true,
        isShortIcon: true,
        className: "text-center salary-ucl",
      },
      {
        Header: "UIL",
        accessor: "uil",
        title: "Uninformed Leave",
        isInfoIcon: true,
        isShortIcon: true,
        className: "text-center salary-uil",
      },
      {
        Header: "LP",
        accessor: "lp",
        title: "Late Punch",
        isInfoIcon: true,
        isShortIcon: true,
        className: "text-center salary-lp",
      },
      {
        Header: "Total Leaves",
        accessor: "total_leaves",
        title: "Late Punch",
        isInfoIcon: true,
        isShortIcon: true,
        className: "text-center salary-total_leaves",
      },
      {
        Header: "Net Leaves",
        accessor: "net_leaves",
        title: "Net Leaves",
        isInfoIcon: true,
        isShortIcon: true,
        className: "text-center salary-total_net_leaves",
        Cell: cellProps => {
          return (
            <div className="text-center d-flex justify-content-center align-items-center">
              {/* <Select
                    placeholder="Select"
                    className="basic-multi-select"
                    classNamePrefix=" select"
                    styles={colourStyles}
                    options={days}
                  /> */}
              <Link
                onClick={() => setApplyNetLeave(true)}
                className="btn btn-save  fix-btn btn-label pe-0"
              >
                <i className="bi bi-plus-square me-2 icon-size label-icon"></i>
                <span>Apply</span>
              </Link>
            </div>
          )
        },
      },
      {
        Header: "Worked Days",
        accessor: "worked_days",
        title: "Worked Days",
        isInfoIcon: true,
        isShortIcon: true,
        className: "text-center salary-worked-days",
      },
      {
        Header: "Amount",
        accessor: "amount",
        title: "Amount",
        isInfoIcon: true,
        isShortIcon: true,
        className: "text-center salary-amount",
      },
    ],
    []
  )

  const data = [
    {
      id: 1,
      name: "Rahul Ovhal",
      total_days: "25",
      asl: "0",
      usl: "0",
      ael: "0",
      uel: "0",
      acl: "0",
      ucl: "0",
      uil: "0",
      lp: "0",
      total_leaves: "0",
      net_leaves: "0",
      worked_days: "25",
      amount: "100000",
    },
    {
      id: 2,
      name: "Kunj",
      total_days: "25",
      asl: "0",
      usl: "0",
      ael: "0",
      uel: "0",
      acl: "0",
      ucl: "0",
      uil: "0",
      lp: "0",
      total_leaves: "0",
      net_leaves: "0",
      worked_days: "25",
      amount: "100000",
    },
    {
      id: 3,
      name: "Yasir",
      total_days: "25",
      asl: "0",
      usl: "0",
      ael: "0",
      uel: "0",
      acl: "0",
      ucl: "0",
      uil: "0",
      lp: "0",
      total_leaves: "0",
      net_leaves: "0",
      worked_days: "25",
      amount: "100000",
    },
    {
      id: 4,
      name: "Zain",
      total_days: "25",
      asl: "0",
      usl: "0",
      ael: "0",
      uel: "0",
      acl: "0",
      ucl: "0",
      uil: "0",
      lp: "0",
      total_leaves: "0",
      net_leaves: "0",
      worked_days: "25",
      amount: "100000",
    },
    {
      id: 5,
      name: "Mayur",
      total_days: "25",
      asl: "0",
      usl: "0",
      ael: "0",
      uel: "0",
      acl: "0",
      ucl: "0",
      uil: "0",
      lp: "0",
      total_leaves: "0",
      net_leaves: "0",
      worked_days: "25",
      amount: "100000",
    },
    {
      id: 6,
      name: "Manav",
      total_days: "25",
      asl: "0",
      usl: "0",
      ael: "0",
      uel: "0",
      acl: "0",
      ucl: "0",
      uil: "0",
      lp: "0",
      total_leaves: "0",
      net_leaves: "0",
      worked_days: "25",
      amount: "100000",
    },
    {
      id: 7,
      name: "Mohit",
      total_days: "25",
      asl: "0",
      usl: "0",
      ael: "0",
      uel: "0",
      acl: "0",
      ucl: "0",
      uil: "0",
      lp: "0",
      total_leaves: "0",
      net_leaves: "0",
      worked_days: "25",
      amount: "100000",
    },
    {
      id: 8,
      name: "Divyansh",
      total_days: "25",
      asl: "0",
      usl: "0",
      ael: "0",
      uel: "0",
      acl: "0",
      ucl: "0",
      uil: "0",
      lp: "0",
      total_leaves: "0",
      net_leaves: "0",
      worked_days: "25",
      amount: "100000",
    },
  ]

  return (
    <React.Fragment>
      {isLoading && <Loader />}
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            title={"Payroll management"}
            breadcrumbItem={"Salary Sheet"}
          />
          <Row>
            <Col lg={12} className="p-0">
              <Card>
                <CardBody>
                  <div className="responsive-table">
                    <TableContainer columns={columns} data={data} />
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      {/* Renew Project  */}
      <div
        className={`note-sticky-form ${applyNetLeave ? "d-block" : "d-none"}`}
      >
        <Draggable>
          <ResizableBox
            width={900}
            style={{
              position: "fixed",
              top: "30%",
              right: "30%",
              zIndex: "1055",
              backgroundColor: "#fff",
            }}
          >
            <div className="modal-header pe-4">
              <h5 className="modal-title mt-0">Apply Net Leave</h5>
            </div>

            <div className="modal-body pe-4">
              <Form
                // onSubmit={handleEditSubmit}
                className="row d-flex justify-content-center align-items-center"
              >
                <div className="col-md-4 d-flex justify-content-end align-items-center ps-3">
                  <div className="text-center">
                    <img src={dayoff} alt="Addepe" style={{ width: "90%" }} />
                  </div>
                </div>

                <div className="col-md-7 d-flex flex-column ">
                  <div className="col-12 d-flex gap-4 mb-3 flex-wrap">
                    <div className="col-md-4">
                      <label htmlFor="">Days</label>
                      <Select
                        placeholder="Select Days"
                        className="basic-multi-select"
                        classNamePrefix=" select"
                        styles={colourStyles}
                        options={days}
                      />
                    </div>
                  </div>
                  <div className="col-12">
                    <label htmlFor="">Reason</label>
                    <textarea type="text" className="form-control" />
                  </div>

                  <div className="my-4 text-end">
                    <button className=" btn btn-save btn-label">
                      <i className="fas fa-save me-2 label-icon"></i>
                      Save
                    </button>
                    <a
                      onClick={() => setApplyNetLeave(false)}
                      className=" btn ms-md-2 btn-red btn-label"
                    >
                      <i className="dripicons-cross me-2 icon-center label-icon"></i>
                      CANCEL
                    </a>
                  </div>
                </div>
              </Form>
            </div>
          </ResizableBox>
        </Draggable>
      </div>
      <AccessDeniedPopup
        modal_Access={modal_Access}
        setAccessDenied={setAccessDenied}
      />
    </React.Fragment>
  )
}

export default SalarySheet
